import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { RootState } from 'store';

import { JoinState } from './join.types';

const initialState: JoinState = {
  appointment: {
    _id: '',
    appointmentDescription: '',
    appointmentMethod: 'video',
    appointmentTypeId: '',
    bookedSlotId: undefined,
    code: '',
    displayName: '',
    doctorId: undefined,
    endTime: '',
    slotBookedAt: '',
    startTime: '',
    status: 'pending'
  },
  mifs: [],
  subscription: {
    planCode: '',
    planId: '',
    planPricePoint: ''
  },
  user: {
    email: '',
    firstName: '',
    lastName: '',
    termsAndConditionsAccepted: false,
    timezone: ''
  }
};

const joinSlice = createSlice({
  initialState,
  name: 'join',
  reducers: {
    clearFlowData: () => {
      return initialState;
    },
    setAppointmentData: (state, action: PayloadAction<Partial<JoinState['appointment']>>) => {
      state.appointment = {
        ...state.appointment,
        ...action.payload
      };
    },
    setMifsData: (state, action: PayloadAction<JoinState['mifs'][number]>) => {
      const { answers, containsSyncOnlyAnswers, id } = action.payload;
      const mifToReplace = state.mifs.find((mif) => mif.id === id);
      if (!mifToReplace) {
        state.mifs.push({ answers, containsSyncOnlyAnswers, id });
      } else {
        const index = state.mifs.indexOf(mifToReplace);
        state.mifs[index] = { answers, containsSyncOnlyAnswers, id };
      }
    },
    setSubscriptionData: (state, action: PayloadAction<Partial<JoinState['subscription']>>) => {
      state.subscription = {
        ...state.subscription,
        ...action.payload
      };
    },
    setUserData: (state, action: PayloadAction<Partial<JoinState['user']>>) => {
      state.user = {
        ...state.user,
        ...action.payload
      };
    }
  }
});

export const { clearFlowData, setAppointmentData, setMifsData, setSubscriptionData, setUserData } =
  joinSlice.actions;

export const selectJoin = (state: RootState) => state.join;

export default joinSlice.reducer;
